import Alpine from 'alpinejs';
import { Availibilities, AvailibilitySlot } from '../booking/types';
import { getUserData } from '../../helpers/user'
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';

interface QuickBookingFormAlpine extends AlpineComponentTryba {
    availabilities: Availibilities | null;
    loadingMeethours: boolean;
    slotStep: number;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('initQuickBookingForm', (): QuickBookingFormAlpine => {
        return {
            currentPage: 1,
            availabilities: null,
            limit: 3,
            loadingMeethours: false,
            slotStep: 0,
            currentDate: new Date(),
            init(): void {
                // Bg color of section
                document.querySelector('.express_appointment_form')?.querySelector('.left-0')?.classList.add('!h-full');
                this.loadingMeethours = true;
                this.getAvailabilities();
            },
            async getAvailabilities(): Promise<void> {
                this.loadingMeethours = true;

                const dataYear = this.currentDate.toLocaleString('default', { year: 'numeric' });
                const dataMonth = this.currentDate.toLocaleString('default', { month: '2-digit' });
                const dataDay = this.currentDate.toLocaleString('default', { day: '2-digit' });
                const formattedDate = `${dataYear}-${dataMonth}-${dataDay}`;

                let shopCode: string|null = null;
                const userData = getUserData();
                if (userData && userData.shop) {
                    shopCode = userData.shop.clientNumber;
                }

                this.limit = this.$store.global.isMobile ? 3 : 7;

                try {
                    const newUrl = `/api/espace-conseil/disponibilites/${shopCode}/?start=${formattedDate}&limit=${this.limit}&page=${this.currentPage}`;
                    const response = await fetch(newUrl);
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    this.availabilities = await response.json();
                } finally {
                    this.loadingMeethours = false;
                }
            },
            handleClickSlot(slot: AvailibilitySlot, item: AvailibilitySlot): void {
                //Reset slots
                if (this.choice) {
                    Object.values(this.availabilities as Availibilities).forEach(({ slots }) => {
                        Object.values(slots).forEach((slot: AvailibilitySlot) => {
                            slot.active = false;
                        });
                    });
                }
                //Get stepChoice object
                this.choice = slot;
                let formattedDateRecap: string;
                //Format for recap
                if (this.choice.from) {
                    const date = new Date(this.choice.from.date);
                    const dataDayRecap = date.toLocaleDateString('default', { day: '2-digit' });
                    const dataMonthRecap = date.toLocaleDateString('default', { month: 'long' });
                    const dataYearRecap = date.toLocaleDateString('default', { year: 'numeric' });
                    const dataHourRecap = date.getHours().toString().padStart(2, '0');
                    const dataMinutesRecap = date.getMinutes().toString().padStart(2, '0');
                    formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ${dataHourRecap}:${dataMinutesRecap}`;
                } else {
                    const dataDayRecap = item.date
                    const dataMonthRecap = item.month
                    const dataYearRecap = item.year
                    formattedDateRecap = `${dataDayRecap} ${dataMonthRecap} ${dataYearRecap} - ` + this.choice.prettySlot
                }
                window.localStorage.setItem('ab-quick-meethours-prettySlot', formattedDateRecap);
                window.localStorage.setItem('ab-quick-meethours-slot', this.choice.value);
                window.location.href = `/demande-de-rendez-vous/?depuis-express#etape2`;
            },
            nextAvailabilities(): void {
                const step = this.limit;
                this.slotStep = this.slotStep + 1
                this.currentDate.setDate(this.currentDate.getDate() + step);
                this.currentPage = this.currentPage + 1
                this.getAvailabilities();
            },
            previousAvailabilities(): void {
                const step = this.limit;
                this.slotStep = this.slotStep - 1
                this.currentDate.setDate(this.currentDate.getDate() - step);
                this.currentPage = this.currentPage - 1
                this.getAvailabilities();
            },
        };
    });
});
